import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';

@Component({
    selector: 'lib-rc-item-drawer',
    template: `<ng-template #signleItemDrawer>
  <ng-content></ng-content>
</ng-template>`,
    styles: [``]
})
export class RcItemDrawerComponent implements OnInit {
    @ViewChild('signleItemDrawer', {read: TemplateRef}) signleItemDrawer;


    ngOnInit(): void {

    }
}